import { EVENT_TYPES } from "store/types";

const initialState = {
  events: [],
  totalCount: 0,
  approvedCount: 0,
  pendingCount: 0,
  currentPage: 1,
  loading: false,
  event: null,
  bookings: [],
  booking: null,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENT_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case EVENT_TYPES.FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload.results,
        totalCount: action.payload.count,
        approvedCount: action.payload.approved_count,
        pendingCount: action.payload.unapproved_count,
        currentPage: action.payload.page,
      };

    case EVENT_TYPES.FETCH_EVENT_SUCCESS:
      return { ...state, event: action.payload };

    case EVENT_TYPES.FETCH_EVENT_BOOKINGS_SUCCESS:
      return { ...state, bookings: action.payload };

    case EVENT_TYPES.FETCH_EVENT_BOOKING_SUCCESS:
      return { ...state, booking: action.payload };

    default:
      return state;
  }
};

export default eventReducer;
